import { Injectable } from '@angular/core';
@Injectable({
  providedIn: 'root'
})
export class StatusHandlerService {

  constructor() { }

  public GetStatusId(status: number, isDelete: boolean): any {
    if (isDelete) {
      return 4;
    }
    else if (status == 1) {
      return 2;
    }
    else if (status == 3) {
      return 3;
    }
    else if (status == 2) {
      return 1;
    }
    else if (status == 4) {
      return 1;
    }
  }

    public GetConfirmationMessage(status: number, moduleName: string): any {
    if (status == 1) {
      return "Are you sure you want to activate " + moduleName + "?";
    }
    else if (status == 2) {
      return "Are you sure you want to deactivate " + moduleName + "?";
    }

    else if (status == 4) {
      return "Are you sure you want to delete " + moduleName + "?";
    }
  }
}
